export default {
  data(){
    return {
      isModalOpend      : false,
      editorFieldHeight : null
    };
  },

  watch : {
    editorFieldHeight(value){
      if(value === null) return;

      this.$refs.editorField.style.height = value + 'px';
    }
  },

  methods : {
    handleCloseModal(){
      this.editorFieldHeight      = null;
      this.shouldShowInkCounter   = false;
      this.isModalOpend           = false;
      this.isQuillMounted         = false;
      this.titleData              = '';
      this.editorData             = null;
      this.defaultTitle           = '';
      this.defaultBodyDeltaString = '';

      this.clearDraftInterval();

      switch(this.editorBehaviour){
        case 'new':
          this.$store.dispatch({
            type        : 'createButton/updateOpenEditor',
            editorType  : 'park',
            value       : false,
          });
        break;

        case 'edit':
          this.$store.dispatch({
            type  : 'parkNote/updateIsOpenEditEditorModal',
            value : false
          });
        break;
      }
    },

    handleAfterEnterContent(){
      this.calcEditorHeight();
    },

    handleAfterdAfterEnterContent(){
      this.shouldShowInkCounter = true;
    },

    handleBeforeEnterContent(){
      this.$emit('beforeEnterContent');

      this.isModalOpend = true;
    },

    handleCloseOverlay(){
    },

    calcEditorHeight(){
      const clientHeight = {
        editorBox   : this.getClientRectHeight(this.$refs['editorBox']),
        buttonField : this.getClientRectHeight(this.$refs['buttonField'])
      };

      this.editorFieldHeight = (clientHeight.editorBox - clientHeight.buttonField);
    },

    handleWindowResize(){
      this.calcEditorHeight();
    }
  },

  created(){
    window.addEventListener('resize', this.handleWindowResize);
  },

  beforeDestroy(){
    window.removeEventListener('resize', this.handleWindowResize);
  }
}